import { computed, ref, type Ref } from 'vue';
import { createItemMediaPlayerOpsStub, type ItemMediaPlayerOps } from './itemMediaPlayerOps';


export class ItemDetailsState {
  private _player: Ref<ItemMediaPlayerOps> = ref(createItemMediaPlayerOpsStub());

  public readonly player = computed(() => this._player.value);

  constructor() { }

  public setPlayer(itemMediaPlayerOps: ItemMediaPlayerOps) {
    this._player.value.clear();
    this._player.value = itemMediaPlayerOps;
  }
}
